// Email dell'admin/creatore dell'app: unico gestore di banner e verifiche.
// Deve coincidere con is_app_admin() lato database.
export const APP_ADMIN_EMAIL = 'nisos@live.it';

export function isAppAdminEmail(email: string | null | undefined): boolean {
  return String(email ?? '').trim().toLowerCase() === APP_ADMIN_EMAIL;
}
